/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MtBillingType {
    MONTHLY = 'MONTHLY',
    PER_WORD = 'PER_WORD',
    FREE_TRIAL = 'FREE_TRIAL',
    FREE = 'FREE',
    MONTHLY_FLAT_RATE = 'MONTHLY_FLAT_RATE',
}
